import {rYAxis} from "./y-axis";
import {cFieldGroupAxes} from "../../../common/field-group-axes";

export const YAxes = (yAxis) => (yAxis ? Object.keys(yAxis).map((k) => rYAxis(k)) : []);
